import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addSystemPrompt,
  deleteSystemPrompt,
  fetchSystemPromptsList,
  updateSystemPrompt,
} from "../../apis/systemPrompts";

import type { SystemPromptPayload } from "../../utils/types/systemPrompts";

export const fetchSystemPromptsData = createAsyncThunk(
  "systemPrompts/fetchSystemPrompts",
  async (_, { rejectWithValue }) => {
    try {
      return await fetchSystemPromptsList();
    } catch (error: any) {
      return rejectWithValue(error?.message);
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as any;
      return !state.systemPrompts.isDataFetched;
    },
  },
);

export const addSystemPromptData = createAsyncThunk(
  "systemPrompts/addSystemPrompt",
  async (
    {
      data,
    }: {
      data: SystemPromptPayload;
    },
    { rejectWithValue },
  ) => {
    try {
      return await addSystemPrompt(data);
    } catch (error: any) {
      return rejectWithValue(error?.message);
    }
  },
);

export const updateSystemPromptData = createAsyncThunk(
  "systemPrompts/updateSystemPrompt",
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: SystemPromptPayload;
    },
    { rejectWithValue },
  ) => {
    try {
      const response = await updateSystemPrompt(id, data);
      return { success: true, data: response };
    } catch (error: any) {
      return rejectWithValue(error?.message);
    }
  },
);

export const deleteSystemPromptData = createAsyncThunk(
  "systemPrompts/deleteSystemPrompt",
  async (
    {
      id,
    }: {
      id: string;
    },
    { rejectWithValue },
  ) => {
    try {
      return await deleteSystemPrompt(id);
    } catch (error: any) {
      return rejectWithValue(error?.message);
    }
  },
);
